import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { FiLogOut, FiMenu, FiX } from 'react-icons/fi';
import { useState } from 'react';
import logo from '../assets/logo/logo.png';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="bg-stroke border-b border-stroke relative z-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/dashboard" className="flex items-center space-x-2">
              <img src={logo} alt="Task Galaxy Logo" className="h-10" />
              <span className="text-2xl font-bold bg-gradient-to-r from-purple-100 to-purple-300 bg-clip-text text-transparent">
                Tasks
              </span>
            </Link>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-6">
            <Link
              to="/dashboard"
              className="text-dark-100 hover:text-purple-100 transition-colors"
            >
              Dashboard
            </Link>
            {user?.role !== 'productManager' && (
              <Link
                to="/create-task"
                className="text-dark-100 hover:text-purple-100 transition-colors"
              >
                New Task
              </Link>
            )}
            {(user?.role === 'teamLead' || user?.role === 'admin' || user?.role === 'productManager') && (
              <Link
                to="/teams"
                className="text-dark-100 hover:text-purple-100 transition-colors"
              >
                Teams
              </Link>
            )}
            {(user?.role === 'admin' || user?.role === 'productManager') && (
              <Link
                to="/progress"
                className="text-dark-100 hover:text-purple-100 transition-colors"
              >
                Progress
              </Link>
            )}
            {(user?.role === 'teamLead' || user?.role === 'admin' || user?.role === 'productManager') && (
              <Link
                to="/users"
                className="text-dark-100 hover:text-purple-100 transition-colors"
              >
                {(user?.role === 'admin' || user?.role === 'productManager') ? 'Users' : 'Team'}
              </Link>
            )}
            <Link
              to="/history"
              className="text-dark-100 hover:text-purple-100 transition-colors"
            >
              History
            </Link>
            <Link
              to="/time"
              className="text-dark-100 hover:text-purple-100 transition-colors"
            >
              Time
            </Link>
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-2">
                <div className="w-8 h-8 rounded-full bg-purple-300 flex items-center justify-center text-white text-sm font-semibold">
                  {user?.name?.charAt(0).toUpperCase()}
                </div>
                <span className="text-white">{user?.name}</span>
                <span className="text-dark-100 text-xs bg-dark-300 px-2 py-1 rounded">
                  {user?.role}
                </span>
              </div>
              <button
                onClick={handleLogout}
                className="flex items-center space-x-2 text-dark-100 hover:text-purple-100 transition-colors"
              >
                <FiLogOut />
                <span>Logout</span>
              </button>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="text-white p-2"
            >
              {mobileMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden border-t border-stroke bg-stroke">
          <div className="px-4 pt-2 pb-3 space-y-3">
            <Link
              to="/dashboard"
              onClick={() => setMobileMenuOpen(false)}
              className="block text-dark-100 hover:text-purple-100 transition-colors"
            >
              Dashboard
            </Link>
            {user?.role !== 'productManager' && (
              <Link
                to="/create-task"
                onClick={() => setMobileMenuOpen(false)}
                className="block text-dark-100 hover:text-purple-100 transition-colors"
              >
                New Task
              </Link>
            )}
            {(user?.role === 'teamLead' || user?.role === 'admin' || user?.role === 'productManager') && (
              <Link
                to="/teams"
                onClick={() => setMobileMenuOpen(false)}
                className="block text-dark-100 hover:text-purple-100 transition-colors"
              >
                Teams
              </Link>
            )}
            {(user?.role === 'admin' || user?.role === 'productManager') && (
              <Link
                to="/progress"
                onClick={() => setMobileMenuOpen(false)}
                className="block text-dark-100 hover:text-purple-100 transition-colors"
              >
                Progress
              </Link>
            )}
            {(user?.role === 'teamLead' || user?.role === 'admin' || user?.role === 'productManager') && (
              <Link
                to="/users"
                onClick={() => setMobileMenuOpen(false)}
                className="block text-dark-100 hover:text-purple-100 transition-colors"
              >
                {(user?.role === 'admin' || user?.role === 'productManager') ? 'Users' : 'Team'}
              </Link>
            )}
            <Link
              to="/history"
              onClick={() => setMobileMenuOpen(false)}
              className="block text-dark-100 hover:text-purple-100 transition-colors"
            >
              History
            </Link>
            <Link
              to="/time"
              onClick={() => setMobileMenuOpen(false)}
              className="block text-dark-100 hover:text-purple-100 transition-colors"
            >
              Time
            </Link>
            <div className="flex items-center justify-between pt-3 border-t border-dark-300">
              <div className="flex items-center space-x-2">
                <div className="w-8 h-8 rounded-full bg-purple-300 flex items-center justify-center text-white text-sm font-semibold">
                  {user?.name?.charAt(0).toUpperCase()}
                </div>
                <div>
                  <div className="text-white">{user?.name}</div>
                  <div className="text-dark-100 text-xs">{user?.role}</div>
                </div>
              </div>
              <button
                onClick={handleLogout}
                className="flex items-center space-x-2 text-dark-100 hover:text-purple-100 transition-colors"
              >
                <FiLogOut />
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;

